/**
 * Save Unlock Content to Secure Storage UseCase
 *
 * Persists the unlocked content record to encrypted local storage
 * so the app can check offline whether a piece of content was already unlocked.
 *
 * Flutter: UnlockContentBottomSheet._unlockVideo() (storage persistence part)
 */
import { SECURE_STORAGE_KEYS } from '@/domain/entities/secureStorage/secureStorageKeys';
import type { UnlockedContentStorage } from '@/domain/entities/secureStorage/secureStorageEntities';
import { SecureStorageWebCrypto } from '@/data/storage/local/secureStorageWebCrypto';

export class SaveUnlockContentToSecureStorageUseCase {
  private readonly storage = SecureStorageWebCrypto.getInstance();

  async execute(mediaRelativePath: string): Promise<void> {
    const storageKey = SECURE_STORAGE_KEYS.UNLOCKED_CONTENT + mediaRelativePath;
    await this.storage.setEncrypted<UnlockedContentStorage>(storageKey, {
      path: mediaRelativePath,
      timestamp: Date.now(),
    });
  }
}
